/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-07-09 14:25:38
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-11 10:09:31
 */
import React, { useEffect, useState } from "react";
import { Button, Divider, Input, Spin } from "antd";
import { Modal, message } from "antd";
import { useTranslation, Trans } from "react-i18next";
import { getCurrentUser } from "@/api/modules/user";
import { setCurrentUser } from "@/redux/modules/global/action";
import { useDispatch, useSelector } from "react-redux";
import iconCoupon from "@/assets/icons/subscription/iconCoupon.svg";
import { BlueText } from "@/language/component";

import {
	fetchRenewPlanUseAmount,
	fetchRenewPlanUseCoupon,
	fetchUseCouponAmount,
	fetchUpgradePlanUseAmount,
	createSubscriptionOrder,
	upgradeSubscriptionOrder
} from "@/api/modules/plan";
import "./index.less";
import { redirectHpp } from "@/components/airwallex/Hpp";

const CouponSubscriptionModal = ({ plan, open, onCancel,onSuccess, type }) => {
	/** 实际支付金额 */
	const [activePayPrice, setActivePayPrice] = useState(0);

	/** 套餐价格 */
	const [planPrice, setPlanPrice] = useState(0);

	/** 使用代金券数值 */
	const [useCouponAmount, setUseCouponAmount] = useState("");

	/**代金券总额  */
	const [couponAmount, setCouponAmount] = useState(0);

	const [loading, setLoading] = useState(false);
	const [renderingLoading, setRenderingLoading] = useState(true);
	const { t } = useTranslation();
	const dispatch = useDispatch();

	useEffect(() => {
		if (!open) {
			return;
		}
		setRenderingLoading(true);
		if (type === "subscribe") {
			fetchUseCouponAmount({
				planProductId: plan.planId
			}).then(res => {
				setUseCouponAmount(res.data.currentCouponAmount ? res.data.currentCouponAmount : "");
				setPlanPrice((res.data.price + (res.data.currentCouponAmount ? res.data.currentCouponAmount : 0)).toFixed(2));
				setActivePayPrice(res.data.price);
				setCouponAmount(res.data.rewardPoints);
				setRenderingLoading(false);
			});
		}

		if (type === "renew") {
			fetchRenewPlanUseAmount({
				planProductId: plan.planId
			}).then(res => {
				setUseCouponAmount(res.data.currentCouponAmount ? res.data.currentCouponAmount : "");
				setPlanPrice((res.data.price + (res.data.currentCouponAmount ? res.data.currentCouponAmount : 0)).toFixed(2));
				setActivePayPrice(res.data.price);
				setCouponAmount(res.data.rewardPoints);
				setRenderingLoading(false);
			});
		}
		if (type === "upgrade") {
			fetchUpgradePlanUseAmount({
				planProductId: plan.planId
			})
				.then(res => {
					setUseCouponAmount(res.data.currentCouponAmount ? res.data.currentCouponAmount : "");
					setPlanPrice((res.data.price + (res.data.currentCouponAmount ? res.data.currentCouponAmount : 0)).toFixed(2));
					setActivePayPrice(res.data.price);
					setCouponAmount(res.data.rewardPoints);
					setRenderingLoading(false);
				})
				.catch(e => {
					setRenderingLoading(false);
				});
		}
	}, [open]);

	const handleCalculatePrice = value => {
		let price = (planPrice - value).toFixed(2);
		setActivePayPrice(price);
	};

	const reloadCurrentUser = () => {
		getCurrentUser().then(res => {
			dispatch(setCurrentUser(res.data));
		});
	};

	const renderPlanTitle = () => {
		if ((type === "upgrade" && plan?.planId === 1) || (type === "renew" && plan?.planId === 2)) {
			return t("billing.plan.name.professional") + "(30天)";
		} else {
			return t("billing.plan.name.standard") + "(30天)";
		}
	};
	const handleSubmit = async () => {
		if (type === "subscribe") {
			/** 使用代金券创建订阅 */

			/**
			 * plan:1 | 2, **** 1:普通套餐，2: pro
			 */
			setLoading(true);
			createSubscriptionOrder({
				planProductId: plan.planId,
				discountAmount: Number(useCouponAmount)
			})
				.then(res => {
					if (res.code === 200) {
						if (res.data.needRedirect){
							redirectHpp(res.data.paymentIntentId, res.data.clientSecret);
						}else{
							message.success(t("message.success"));
							onSuccess();
						}
						onCancel();
					} else {
						message.error(res.message);
					}
					setLoading(false);
				})
				.catch(e => {
					setLoading(false);
				});
		}
		if (type === "renew") {
			/** 使用代金券续订订阅 */
			setLoading(true);

			fetchRenewPlanUseCoupon({
				discountAmount: useCouponAmount
			})
				.then(res => {
					if (res.code === 200) {
						if (res.data.needRedirect){
							redirectHpp(res.data.paymentIntentId, res.data.clientSecret);
						}else{
							message.success(t("message.success"));
							onSuccess();
						}
						onCancel();
					} else {
						message.error(res.message);
					}
					setLoading(false);
				})
				.catch(e => {
					setLoading(false);
				});
		}
		if (type === "upgrade") {
			/** 使用代金券升级订阅 */
			setLoading(true);

			upgradeSubscriptionOrder({
				discountAmount: useCouponAmount,
				planProductId: 2
			})
				.then(res => {
					if (res.code === 200) {
						if (res.data.needRedirect){
							redirectHpp(res.data.paymentIntentId, res.data.clientSecret);
						}else{
							message.success(t("message.upgrade.subscription.plan.success"));
							reloadCurrentUser()
						}
						onCancel();
					} else {
						message.error(res.message);
					}
					setLoading(false);
				})
				.catch(e => {
					setLoading(false);
				});
		}
	};
	return (
		<Modal
			open={open}
			closable={true}
			okButtonProps={{
				loading: loading
			}}
			okText={t("action.button.confirm")}
			cancelText={t("action.button.cancel")}
			onCancel={() => {
				setUseCouponAmount();
				onCancel();
				setLoading(false);
			}}
			destroyOnClose={true}
			onOk={() => {
				handleSubmit();
				setUseCouponAmount();
			}}
			title={type === "upgrade" ? t("billing.blank.button.upgrade") : t("billing.blank.button.Purchase Subscription")}
		>
			<Divider />
			<Spin spinning={renderingLoading}>
				<div className="planItemLayout">
					<span>{t("billing.coupon.plan")}</span>
					<span>{renderPlanTitle()}</span>
				</div>
				<div className="planItemLayout">
					<span>{t("billing.coupon.plan.price")}</span>
					<span>{planPrice} USD</span>
				</div>

				<Divider />
				<div className="planItemLayout">
					<span>{t("billing.coupon.useCoupon")}</span>
					<div className="inputLayout">
						<Input
							value={useCouponAmount}
							placeholder="0"
							style={{
								textAlign: "right"
							}}
							onChange={({ target: { value } }) => {
								const reg = /^\d*(\.\d{0,2})?$/;
								if (reg.test(value) || value === "") {
									setUseCouponAmount(value);
									handleCalculatePrice(value);
								}
							}}
							onBlur={({ target: { value } }) => {
								if (value === "") {
									value = "";
									setUseCouponAmount(value);
									handleCalculatePrice(value);
								}
							}}
						/>
						{/* <span className="inputError">{t("billing.coupon.useCoupon.mesasge", { dollar: 1 })}</span> */}
						<span className="couponTotal">
							<img src={iconCoupon} alt="" />

							<Trans i18nKey="billing.coupon.total" components={{ important: <BlueText /> }} values={{ amount: couponAmount }} />
						</span>
					</div>
				</div>
				<Divider dashed />

				<div className="planItemLayout">
					<span>{t("billing.coupon.useCoupon.payment.total")}</span>

					<span>
						<span className="totalPrice">{activePayPrice}</span>USD
					</span>
				</div>

				{/* <div className="couponPlanDescrip">{t("billing.coupon.useCoupon.description")}</div> */}
				<Divider />
			</Spin>
		</Modal>
	);
};

export default CouponSubscriptionModal;
